import { useTranslation } from 'react-i18next';
import { BITRIX } from 'common/constants';
import testShape from 'assets/icons/home/hmTestShape.svg';
import testArrow from 'assets/icons/home/hmTestArrow.svg';
import iconClock from 'assets/icons/home/hmIconClock.svg';
import iconSearch from 'assets/icons/home/hmIconSearch.svg';
import testPhoto from 'assets/image/home/hmTestPhoto.webp';
import HomeButton from './HomeButton';
import classes from './HomeTest.module.scss';


// Фото берём из макета: картинка из админки слишком низкого качества.
// Остальные пропсы — для страниц, где блок с другим текстом (например, Geeks Pro):
// заголовок, кнопка, подпись от руки и две подсказки ({ icon, text }).
const HomeTest = ({ image_alt, title, buttonText, buttonHref, note, hint, time }) => {
  const { t } = useTranslation();
  const hintBadge = hint ?? { icon: iconSearch, text: <>Поможет выбрать<br />твоё направление</> };
  const timeBadge = time ?? { icon: iconClock, text: '5-10 минут' };

  return (
    <section className={classes.test}>
      <div className={classes.container}>
        <div className={classes.inner}>
          <div className={classes.text}>
            <h2 className={classes.title} data-aos="fade-up">{title ?? t('TakeTheQuizToFindYourWay')}</h2>
            <div data-aos="fade-up" data-aos-delay="100">
              <HomeButton href={buttonHref ?? BITRIX.test}>{buttonText ?? t('Test')}</HomeButton>
            </div>
          </div>

          {/* Композиция из макета: наклонённые карточки, подпись от руки и подсказки. */}
          <div className={classes.media} data-aos="fade-up" data-aos-delay="150">
            <img className={classes.shape} src={testShape} alt="" />

            <div className={classes.photo}>
              <img src={testPhoto} alt={image_alt || 'Студент Geeks'} loading="lazy" />
            </div>

            <span className={classes.note}>{note ?? 'Твой следующий шаг'}</span>
            <img className={classes.noteArrow} src={testArrow} alt="" />

            <span className={`${classes.badge} ${classes.badgeTime}`}>
              <img src={timeBadge.icon} alt="" />
              {timeBadge.text}
            </span>
            <span className={`${classes.badge} ${classes.badgeHint}`}>
              <img src={hintBadge.icon} alt="" />
              {hintBadge.text}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTest;
